import { formatShapeName } from '@takeshape/util';
/**
 * Construct a shape name used for a mutation input shape.
 */
export function getMutationInputShapeName(verb) {
    return (shapeName) => {
        return formatShapeName([verb, shapeName, 'input'], { shapeNameIndex: 1 });
    };
}
/**
 * Create a shape name variant for an input.
 */
export function getInputShapeName(shapeName) {
    if (shapeName === 'TSRelationship') {
        return shapeName;
    }
    return `${shapeName}Input`;
}
export function getOutputShapeName(name) {
    return name.replace(/(?:Input|PartialInput)$/, '');
}
